import {
  SessionProvider as Provider,
  sessionFor,
  useSignOut as signOutWith,
} from '@porotutu/react/session'
import type { ReactNode } from 'react'
import { leave } from '../api/auth'
import { changeLocaleMutation, type Profile, profileQuery } from './profile'

const bound = sessionFor<Profile>({ profileQuery, changeLocaleMutation })

export const sessionConfig = bound.config
export const useSession = bound.useSession
export const useViewer = bound.useViewer

export const useSignOut = () => signOutWith(leave)

export const SessionProvider = ({ children }: { children: ReactNode }) => (
  <Provider config={sessionConfig}>{children}</Provider>
)

export { useT } from '@porotutu/react/session'
export type { Profile } from './profile'
